import styled from '@emotion/styled/macro';

const isDetail = props => props.variant === 'detail';

export const CountdownWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: transparent;
    box-shadow: none;
    padding: 0;
    width: 100%;
    ${props =>
        isDetail(props) &&
        `
        background-color: #ffffff;
        box-shadow: 0 2px 16px rgba(0, 0, 0, 0.15);
        padding: ${props.theme.spacing.large} ${props.theme.spacing.normal};
        width: auto;
    `}
`;

export const DateTimeHeader = styled.span`
    text-align: center;
    color: ${props => props.theme.colours.textDark};
    font-family: ${props => props.theme.fonts.gtWalsheimProRegular};
    font-size: ${props => props.theme.fontSize.normal};
`;

export const Title = styled.span`
    text-transform: uppercase;
    text-align: center;
    color: ${props => props.theme.colours.textGreen};
    font-family: ${props => props.theme.fonts.gtWalsheimProBold};
    font-size: ${props => props.theme.fontSize.large};
    font-weight: 700;
    padding-top: 0;
    ${props => isDetail(props) && `padding-top: ${props.theme.spacing.normal};`}
`;

export const TimeWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    width: fit-content;
    max-width: 100%;
    margin: 0 auto;
    padding-top: 0;
    justify-content: center;
    gap: ${props => (props.dense ? '6px' : '10px')};
    ${props =>
        isDetail(props) &&
        `
        width: auto;
        gap: normal;
        justify-content: center;
        padding-top: ${props.theme.spacing.large};
    `}
`;

export const TimeUnitWrapper = styled.div`
    display: flex;
    justify-content: space-evenly;
    align-items: flex-end;
    gap: 3px;
    min-width: 0;
    ${props => isDetail(props) && `gap: 2px;`}
`;

export const TimeUnit = styled.div`
    color: ${props => props.theme.colours.textBrightOrange};
    font-family: ${props => props.theme.fonts.digital};
    font-size: ${props =>
        isDetail(props)
            ? props.theme.fontSize.medium
            : props.theme.fontSize.normal};
    white-space: nowrap;
    padding: 0;
    text-align: center;
    ${props =>
        isDetail(props) &&
        `
        color: ${props.theme.colours.textOrange};
        padding: 0 ${props.theme.spacing.xsmall} 0 ${props.theme.spacing.small};
        text-align: left;
    `}
`;

export const TimeUnitDescription = styled.div`
    color: ${props => props.theme.colours.textDark};
    font-family: ${props => props.theme.fonts.gtWalsheimProMedium};
    font-size: ${props =>
        isDetail(props)
            ? props.theme.fontSize.medium
            : props.theme.fontSize.normal};
    line-height: ${props => props.theme.lineHeight.xsmall};
    white-space: nowrap;
    padding: 0;
    ${props =>
        isDetail(props) &&
        `
        font-family: ${props.theme.fonts.gtWalsheimProRegular};
        padding: 0 ${props.theme.spacing.small} 0 0;
    `}
`;
